// extracted by mini-css-extract-plugin
export default {"policies-container":"Policies_policies-container__AOHn3","policies-end":"Policies_policies-end__KYMx3"};